import Logger from '../logger';

// Time in minutes from last activity (open chat or last client message)
// after which Closer chat won't be reloaded
const SESSION_THRESHOLD_MINUTES = 120;

const setSessionStart = () => {
    const date = new Date();
    window.WC._localStorage.set('lastActivityTS', date.getTime());
};

const isSessionExpired = (lastMessageTimestamp = window.WC._localStorage.get('lastActivityTS')) => {
    if (!lastMessageTimestamp) {
        Logger.log('isSessionExpired=false (no timestamp)');
        return false;
    }

    const currentTimeStamp = new Date().getTime();
    const minuteDifference = (currentTimeStamp - lastMessageTimestamp) / 1000 / 60;
    Logger.log(`isSessionExpired minuteDifference=${minuteDifference}`);
    if (minuteDifference > SESSION_THRESHOLD_MINUTES) {
        Logger.log('isSessionExpired=true');
        return true;
    }
    Logger.log('isSessionExpired=false');
    return false;
};

export { setSessionStart, isSessionExpired, SESSION_THRESHOLD_MINUTES };
